import { createFileRoute } from '@tanstack/react-router';
import { SupplierEditorPage } from '@/pages/member-portal/suppliers/SupplierEditorPage';

// Supplier editor. `$id` is either a supplier id (edit) or the literal `new`.
function MemberPortalSupplierEditorRoute() {
	return <SupplierEditorPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/suppliers/$id')({
	component: MemberPortalSupplierEditorRoute,
});
